export var DetectedFormatType;
(function (DetectedFormatType) {
    DetectedFormatType["DETECTED_FORMAT_TYPE_JSON"] = "JSON";
    DetectedFormatType["DETECTED_FORMAT_TYPE_AVRO_CONFLUENT"] = "AVRO_CONFLUENT";
    DetectedFormatType["DETECTED_FORMAT_TYPE_PROTOBUF_CONFLUENT"] = "PROTOBUF_CONFLUENT";
    DetectedFormatType["DETECTED_FORMAT_TYPE_RAW"] = "RAW";
    DetectedFormatType["DETECTED_FORMAT_TYPE_MIXED"] = "MIXED";
})(DetectedFormatType || (DetectedFormatType = {}));
